import { memo } from 'react'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import BaseNode from './BaseNode'
import { WorkflowNodeData } from '@store/workflowStore'

interface StartNodeProps {
  id: string
  data: WorkflowNodeData
  selected?: boolean
}

function StartNode(props: StartNodeProps) {
  return (
    <BaseNode
      {...props}
      icon={<PlayArrowIcon fontSize="small" />}
      showTargetHandle={false}
      showSourceHandle={true}
    />
  )
}

export default memo(StartNode)
